var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-icon"},[_c('i',{class:_vm.iconType}),(_vm.text)?_c('div',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }